const WORKSPACE_ID_KEY = "needl_main_app_workspace_id";

export const getActiveWorkspaceId = (): string | null => {
  try {
    return localStorage.getItem(WORKSPACE_ID_KEY);
  } catch (error) {
    console.error("Failed to get workspace ID from localStorage:", error);
    return null;
  }
};

export const setActiveWorkspaceId = (workspaceId: string): void => {
  try {
    localStorage.setItem(WORKSPACE_ID_KEY, workspaceId);
  } catch (error) {
    console.error("Failed to set workspace ID in localStorage:", error);
  }
};

export const clearActiveWorkspaceId = (): void => {
  try {
    localStorage.removeItem(WORKSPACE_ID_KEY);
  } catch (error) {
    console.error("Failed to clear workspace ID from localStorage:", error);
  }
};
